import { useStores } from '@monorepo/controlled/src/hooks/use-stores';
import { IAdminxStore } from '../../stores';
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { BetweenPagesStateProps } from '@monorepo/tools/src/lib/interfaces/global';
import { id } from '@monorepo/tools/src/lib/types/primitives';

export const useDomainFactorsGet = (mode: 'all' | 'campaign' | 'domain', query?: string | id, hookOptions: BetweenPagesStateProps = {}) => {
	const { domainFactorsStore } = useStores<IAdminxStore>();
	const location = useLocation();
	const isBlockRequest = hookOptions.isBlockRequest ?? false;

	useEffect(() => {
		if (isBlockRequest) {
			return;
		}
		if (mode === 'all') {
			domainFactorsStore.fetchAll();
			return;
		}
		if (!query || (typeof query === 'string' && !query.trim())) {
			return;
		}
		if (mode === 'campaign') {
			domainFactorsStore.fetchByCampaign(query as string);
		} else {
			domainFactorsStore.fetchByDomain(query as string);
		}
	}, [mode, query, location]);

	return {
		error: domainFactorsStore.listStore.getError(),
		isLoading: domainFactorsStore.listStore.getIsLoading(),
		domainFactors: domainFactorsStore.listStore.getList(),
	};
};
